export const MARK_ALL_NOTIFICATIONS_AS_READ_MUTATION = `
  mutation MarkAllNotificationsAsRead($track: [ID!]!, $beforeInclusive: ID) {
    markAllNotificationsAsRead(track: $track, beforeInclusive: $beforeInclusive) {
      unreadCount
      items {
        id
        isRead
      }
    }
  }
`;

export const MARK_NOTIFICATION_AS_READ_MUTATION = `
  mutation MarkNotificationAsRead($id: ID!) {
    markNotificationAsRead(id: $id) {
      item {
        id
        isRead
      }
    }
  }
`;

export const MARK_NOTIFICATION_AS_UNREAD_MUTATION = `
  mutation MarkNotificationAsUnread($id: ID!) {
    markNotificationAsUnread(id: $id) {
      item {
        id
        isRead
      }
    }
  }
`;

export const MARK_NOTIFICATION_AS_PINNED_MUTATION = `
  mutation MarkNotificationAsPinned($id: ID!) {
    markNotificationAsPinned(id: $id) {
      item {
        id
        pinDetails {
          isPinned
          updatedAt
        }
      }
    }
  }
`;

export const MARK_NOTIFICATION_AS_UNPINNED_MUTATION = `
  mutation MarkNotificationAsUnpinned($id: ID!) {
    markNotificationAsUnpinned(id: $id) {
      item {
        id
        pinDetails {
          isPinned
          updatedAt
        }
      }
    }
  }
`;

export const MARK_NOTIFICATION_AS_DISMISSED_MUTATION = `
  mutation MarkNotificationAsDismissed($id: ID!) {
    markNotificationAsDismissed(id: $id) {
      item {
        id
        isDismissed
      }
    }
  }
`;

export const MARK_NOTIFICATION_AS_UNDISMISSED_MUTATION = `
  mutation MarkNotificationAsUndismissed($id: ID!) {
    markNotificationAsUndismissed(id: $id) {
      item {
        id
        isDismissed
      }
    }
  }
`;

export const MARK_ALL_NOTIFICATIONS_AS_DISMISSED_MUTATION = `
  mutation MarkAllNotificationsAsDismissed($track: [ID!]!, $beforeInclusive: ID) {
    markAllNotificationsAsDismissed(track: $track, beforeInclusive: $beforeInclusive) {
      unreadCount
      operationId
      items {
        id
        isDismissed
      }
    }
  }
`;

export const MARK_ALL_NOTIFICATIONS_AS_UNDISMISSED_MUTATION = `
  mutation UndoMarkAllNotificationsAsDismissed($track: [ID!]!, $operationId: ID!) {
    undoMarkAllNotificationsAsDismissed(track: $track, operationId: $operationId) {
      unreadCount
      items {
        id
        isDismissed
      }
    }
  }
`;
